<header class="mass-os-header">
  <div class="mass-os-header__text">
    <p class="mass-os-header__eyebrow">Operaciones</p>
    <h1 class="mass-os-header__title">{{ title }}</h1>
    <p class="mass-os-header__subtitle">{{ subtitle }}</p>
  </div>

  <div class="mass-os-header__meta">
    <div class="mass-os-chip mass-os-chip--muted" *ngIf="serviceCount > 0">
      <span>{{ serviceCount }} servicio{{ serviceCount === 1 ? '' : 's' }}</span>
    </div>
    <div class="mass-os-chip mass-os-chip--accent" *ngIf="selectedCount > 0">
      <span>{{ selectedCount }} seleccionado{{ selectedCount === 1 ? '' : 's' }}</span>
    </div>
    <button
      mat-stroked-button
      type="button"
      class="mass-os-header__hint-btn"
      (click)="showRequirements.emit()"
    >
      {{ requirementsLabel }}
    </button>
  </div>
</header>
